import { lazy } from 'react'

export const AgentReportMap = lazy(() => import('../agentReportMap'))
export const AgentReportAttendancesMap = lazy(
  () => import('../components/agentReportAttendancesMap.component'),
)
export const AgentReportProductionChart = lazy(
  () => import('../components/agentReportProductionChart.component'),
)
export const AgentReportSize = lazy(() => import('../components/agentReportSize.component'))
export const AgentReportHistogram = lazy(
  () => import('../components/agentReportHistogram.component'),
)
export const AgentReportEconomicActivityList = lazy(
  () => import('../components/agentReportEconomicActivityList.component'),
)
export const AgentReportIsBranch = lazy(() => import('../components/agentReportIsBranch.component'))

export function useLazyComponents() {
  return {
    AgentReportMap,
    AgentReportAttendancesMap,
    AgentReportProductionChart,
    AgentReportSize,
    AgentReportHistogram,
    AgentReportEconomicActivityList,
    AgentReportIsBranch,
  }
}
